import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const Title = styled(Type)`
  &.h3 {
    font-size: ${({ theme }) => theme.font.size.md};
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      font-size: ${({ theme }) => theme.font.size.lg};
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${({ theme }) => theme.font.size.lg};
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${({ theme }) => theme.font.size.lg};
    }
  }
  &.h4 {
    font-size: ${({ theme }) => theme.font.size.sm};
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      font-size: ${({ theme }) => theme.font.size.md};
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${({ theme }) => theme.font.size.md};
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${({ theme }) => theme.font.size.md};
    }
  }
  &.h5 {
    font-size: ${({ theme }) => theme.font.size.md};
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      font-size: ${({ theme }) => theme.font.size.md};
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: ${({ theme }) => theme.font.size.md};
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: ${({ theme }) => theme.font.size.md};
    }
  }
  margin-bottom: 0.75rem;
  padding-top: ${({ theme }) => theme.space.sm};
`;
